<template>
    <router-view />
</template>
<script>
/**************************************************************************************************************************************************
ESTA TELA/COMPONENTE NÃO É MAIS UTILIZADO (ESTÁ DEPRECIADO). AS TELAS/COMPONENTES DE REGIÃO CORRETAS SÃO RELACIONADAS A CATEGORIA DE PROMOTOR
***************************************************************************************************************************************************/
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-regiao') {
            next({ name: 'ven-regiao-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-regiao') {
            this.$router.push({ name: 'ven-regiao-list' });
        }
    },
};
</script>
